import THEME from 'pobble-components/dist/theme'

const { FONT_SIZES, COLORS } = THEME

export default {
  groupItem: {
    padding: '20px 0',
    ...FONT_SIZES.BODY_LARGE.STYLE,
    display: 'flex',
    flexDirection: 'row',
    borderBottom: '1px solid #ECECEC'
  },
  checkbox: {
    margin: '0 15px 0 0'
  },
  label: {
    fontWeight: 'bold',
    display: 'flex'
  },
  studentsNumber: {
    fontWeight: 'normal',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    margin: '0 0 0 10px'
  }
}
